import { useContext } from 'react'
import type { AuthContextType as JwtAuthContextType } from '@/contexts/auth/jwt-context'
import { AuthContext } from '@/contexts/auth/jwt-context'

type AuthContextType = JwtAuthContextType

export const useAuth = <T = AuthContextType>() => useContext(AuthContext) as T
